import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildMapExploreCategorySelectedActivityEntry(categoryLabel: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'map_explore_category_selected',
    label: 'Filtered map by category',
    displayText: boundActivityDisplayText(`Filtered map for "${categoryLabel}"`),
    sourcePath: 'trip_planner.map.explore_category',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
